import React, { useEffect, useState } from 'react';

const DEFAULT_LINES = [
  { text: '> visualte.engine :: init', tail: ' OK' },
  { text: '> control plane', tail: ' ONLINE' },
];

const CHAR_MS = 22;
const LINE_PAUSE_MS = 260;

/**
 * Boot-sequence readout: types each line, then stamps its status tail in orange.
 * Respects prefers-reduced-motion by rendering the finished output at once.
 */
export default function BootLine({ lines = DEFAULT_LINES, className = '' }) {
  const [done, setDone] = useState([]);   // fully typed lines
  const [current, setCurrent] = useState(''); // line being typed
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { setDone(lines); setFinished(true); return; }

    let cancelled = false;
    let lineIdx = 0;
    let charIdx = 0;
    let timer;

    const step = () => {
      if (cancelled) return;
      const line = lines[lineIdx];
      if (!line) { setFinished(true); return; }
      if (charIdx <= line.text.length) {
        setCurrent(line.text.slice(0, charIdx));
        charIdx += 1;
        timer = setTimeout(step, CHAR_MS);
      } else {
        setDone((d) => [...d, line]);
        setCurrent('');
        lineIdx += 1;
        charIdx = 0;
        timer = setTimeout(step, LINE_PAUSE_MS);
      }
    };
    timer = setTimeout(step, 300);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [lines]);

  return (
    <div className={`boot-line ${className}`} aria-hidden="true" style={{ minHeight: `${lines.length * 1.6}em` }}>
      {done.map((l, i) => (
        <div key={i}>{l.text}<span className="ok">{l.tail}</span></div>
      ))}
      {!finished && <div>{current}<span className="cursor-blink" /></div>}
      {finished && <div>{'> awaiting input'}<span className="cursor-blink" /></div>}
    </div>
  );
}
